import { LAYOUT_STORE_NAME } from '../../components/Shared/Constants';

const initialState = {
  isAlertBannerOpen: false,
  activeBrowseComponent: '',
  isBrowseFeedScrolled: false,
  shouldOpenBrowseSearchModal: false,
};

const reducerName = LAYOUT_STORE_NAME;

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Update'.concat(reducerName):
      return {
        ...state,
        ...action.updatedResult,
      };
    default:
      return state;
  }
};

export default layoutReducer;
